<template>
    <v-container grid-list-sm text-xs-left>
        <v-layout
                row
                wrap
                pa-2
                align-end
        >
            <v-flex xs12 md4 pb0 mb0 >
                <span v-if="challangesFlag"
                        class="headline"
                >
                    Challenges
                </span>
                <span v-else
                      class="headline"
                >
                    No Challenge Found
                </span>
            </v-flex>
            <v-flex xs6 md4 class="pl-3">
                <v-text-field
                        class="pt-1"
                        v-model="search"
                        :append-icon="search?'close':'search'"
                        @click:append="search = ''"
                        label="Search"
                        single-line
                        hide-details
                        @keydown.native.escape="search=''">
                </v-text-field>
            </v-flex>
            <v-flex v-if="!this.published" xs6 md4>
                <v-layout justify-end>
                    <v-btn round
                           depressed
                           color="success"
                           @click="navigate('newChallenge',true)"
                    >
                        Create Challenge
                        <v-icon right dark>
                            add
                        </v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex v-for="challenge in filteredItems"
                    :key="challenge._id"
                    xs12 sm6 md6 lg4 xl4
                    pa-2
            >
                <v-card>
                    <v-img
                            :lazy-src="require('@/assets/img/innovation/loadingBlueGreen.gif')"
                            :src="challangesImgs[challenge._id]"
                            aspect-ratio="2.75"
                            height="200px"
                    >
                    </v-img>

                    <v-card-title primary-title>
                        <v-flex xs12 class="headline block-ellipsis-title">{{challenge.Title}}</v-flex>
                        <v-flex xs12 class="block-ellipsis-description" v-html="challenge.Description"></v-flex>
                    </v-card-title>

                    <v-card-text>
                        <v-flex xs12 class="block-ellipsis-tags">
                            <v-chip
                                    v-for="tag in challenge.tags"
                                    slot="activator"
                                    column
                                    disabled
                                    color="blue"
                                    outline>
                                {{ tag }}
                            </v-chip>
                        </v-flex>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                                slot="activator"
                                color="blue"
                                flat
                                dark
                                class="elevation-0"
                                @click="navigate(challenge._id,false)"
                        >
                            Edit
                        </v-btn>

                        <v-tooltip color="amber lighten-4" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        slot="activator"
                                        color="blue"
                                        flat
                                        dark
                                        class="elevation-0"
                                        @click="openStartupRegisteredTreeViewDialog(challenge)"
                                        v-on="on"
                                >
                                    Startups
                                </v-btn>
                            </template>
                            <v-card color="amber lighten-4" elevation="0">
                                <v-card-title>
                                    <v-layout column wrap>
                                        <v-flex>
                                            <span class="subheading">Click here to see list of <strong>startups registered</strong> for this challenge.</span>
                                        </v-flex>
                                    </v-layout>
                                </v-card-title>
                            </v-card>
                        </v-tooltip>

                        <v-spacer></v-spacer>

                        <v-btn
                                small
                                round
                                icon
                                color="red"
                                class="white--text"
                                @click="openDeleteChallengeDialog(challenge)"
                        >
                            <v-icon small dark>
                                close
                            </v-icon>
                        </v-btn>
                        <v-btn icon @click="challenge.selected  =! challenge.selected">
                            <v-icon>{{ challenge.selected ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-card-text v-show=challenge.selected>
                        <v-flex xs12><span class="font-weight-bold">Reward: </span> {{challenge.reward}} </v-flex>
                        <v-flex xs12><span class="font-weight-bold">Deadline: </span> {{challenge.date}} </v-flex>
                        <v-flex xs12 v-if="challenge.published"><span class="font-weight-bold">Publication Date: </span> {{challenge.datePublished}} </v-flex>
                    </v-card-text>



                </v-card>
            </v-flex>

            <!-- TreeView for Delete Challenge -->
            <v-dialog
                    v-model="deleteChallengeDialog"
                    max-width="650"
            >
                <v-card>
                    <v-card-title class="headline">Deleting "{{ challengeToDelete.Title}}" </v-card-title>
                    <v-card-text>
                        Are you sure?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat="flat"
                                @click="closeDeleteChallengeDialog()"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                                color="red"
                                flat="flat"
                                @click="deleteChallenge()"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- TreeView for Registered Startups -->
            <v-dialog
                    v-model="startupRegisteredTreeViewDialog"
                    max-width="1000"
            >
                <v-card>
                    <v-card-title class="headline">Registered Startup</v-card-title>
                    <v-card-text class="subheading">Click on startup's name to see details</v-card-text>

                    <StartupRegisteredTreeView :challenge='selectedChallenge'></StartupRegisteredTreeView>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat="flat"
                                @click="closeStartupRegisteredTreeViewDialog()"
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-layout>
    </v-container>
</template>

<script>

    import RouterService from "@/helpers/RouterService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import StartupRegisteredTreeView from "./StartupRegisteredTreeView";

    export default {
        name: "ChallengeHomePage",
        components: {StartupRegisteredTreeView},
        props: {
            published: Boolean,
            expired: Boolean,
        },
        computed: {
            filteredItems() {
                let filtered = [];
                for (let i=0; i<this.challenges.length; i=i+1){
                    if(this.challenges[i].Title.toLowerCase().includes(this.search.toLowerCase())){
                        filtered.push(this.challenges[i]);
                    }
                }

                filtered.sort(function(a, b){
                    var keyA = new Date(a.datePublished),
                        keyB = new Date(b.datePublished);
                    // Compare the 2 dates
                    if(keyA > keyB) return -1;
                    if(keyA < keyB) return 1;
                    return 0;
                });

                return filtered;
            },
        },
        data() {
            return {
                header: "Challenges",
                addNewChallengeTitle: "Add new",
                challenges: [],
                challangesImgs: {},
                challangesFlag: false,
                selectedChallenge: {},
                deleteChallengeDialog: false,
                startupRegisteredTreeViewDialog: false,
                search: "",
                challengeToDelete: {}
            };
        },
        created() {
            this.getChallenges();
        },
        methods: {
            getRequireImg(path){
                console.log('require   : ----- '+path);
                return require(path)
            },
            navigate(id, newFlag) {
                let path = {
                    name: "ChallengeDetails",
                    params: {
                        _id: id,
                        newFlag: newFlag,
                    },
                };
                RouterService.goTo(path);
            },
            openDeleteChallengeDialog(challenge) {
                this.challengeToDelete = challenge;
                this.deleteChallengeDialog = true;
            },
            closeDeleteChallengeDialog() {
                this.selectedChallenge = {};
                this.deleteChallengeDialog = false;
            },
            openStartupRegisteredTreeViewDialog(challenge) {
                this.selectedChallenge = challenge;
                this.startupRegisteredTreeViewDialog = true;
            },
            closeStartupRegisteredTreeViewDialog() {
                this.selectedChallenge = {};
                this.startupRegisteredTreeViewDialog = false;
            },
            getChallenges() {
                let url = "";
                if(this.published && this.expired){
                    url = UrlsService.getChallengesPubExp;
                } else if(this.published && !this.expired){
                    url = UrlsService.getChallengesPubNotExp;
                } else if(!this.published && !this.expired) {
                    url = UrlsService.getChallengesNotPubNotExp;
                } else if(!this.published && this.expired){
                    url = UrlsService.getChallengesNotPubExp;
                }
                let requestUrl = {
                    url: url,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        integrationInteractionRequest: {

                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "List Challenges",
                    loading: "Waiting for list of challenges...",
                    error: "Cannot get challenges...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.challenges = [];
                        let responseChallenges = responseSuccess.response.challenges;

                        for (let i = 0; i < responseChallenges.length; i++) {
                            responseChallenges[i]['selected'] = false
                            this.challenges.push(responseChallenges[i])
                            this.downloadImage(responseChallenges[i]._id)
                        }

                        if(this.challenges.length == 0){
                            this.challangesFlag = false
                        }
                        else{
                            this.challangesFlag = true
                        }
                    });
            },
            downloadImage(idImg){
                let requestUrl = {
                    url: UrlsService.challengeOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "GET_IMAGE",
                        challengeRequest: {
                            challenge: {
                                _id: idImg
                            },
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Challenges Images",
                    loading: "Waiting for list of images challenges...",
                    error: "Cannot get challenges images...",
                };
                let options = {
                    loadingType: "silent",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let responseImage = responseSuccess.response.challenges[0];
                        this.challangesImgs[idImg] = responseImage.imgBase64;
                        this.$forceUpdate();
                    });
            },
            deleteChallenge(){
                this.deleteChallengeDialog = false;

                let requestUrl = {
                    url: UrlsService.challengeOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "DELETE",
                        challengeRequest: {
                            challenge: {
                                _id: this.challengeToDelete._id
                            }
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Delete Challenge",
                    loading: "Waiting for deletion of challenge...",
                    error: "Cannot delete challenge...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.getChallenges()
                    });
            },
        },
    }
</script>

<style scoped>

    .ellipsis {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .block-ellipsis-title {
        display: block;
        display: -webkit-box;
        max-width: 100%;
        height: 35px;
        margin: 0 auto 0 0;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: hidden; /* auto (for vertical scrolling) or hidden */
    }

    .block-ellipsis-description {
        display: block;
        display: -webkit-box;
        max-width: 100%;
        height: 63px;
        margin: 0 auto 0 0;
        font-size: 14px;
        line-height: 1.5;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: hidden; /* auto (for vertical scrolling) or hidden */
    }

    .block-ellipsis-tags {
        display: block;
        display: -webkit-box;
        max-width: 100%;
        height: 84px;
        margin: 0 auto 0 0;
        line-height: 1.5;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: auto; /* auto (for vertical nad orizontal scrolling) or hidden */
    }

    .my-span {
        background-color: white;
        opacity: 0.5;
        color: black;
        font-weight: bold;
        margin-right: 5%;
        margin-top: 2.5%;
        float: right;
    }

</style>